import React, { useEffect } from 'react';
import { Paper, Box } from '@mui/material';
import SectionLayoutSettings from './SectionLayoutSettings';
import SectionControls from './SectionControls';
import HeaderEditor from './HeaderEditor';
import SectionItemsList from './SectionItemsList';
import SectionBackgroundSettings from './SectionBackgroundSettings';

let nextSectionOrder = 0;

const SectionDetailPanel = ({
  sectionId,
  items,
  sections,
  setSections,
  headers,
  setHeaders,
  work_item_presets,
  default_profiles,
}) => {
  // Assign order to new sections
  useEffect(() => {
    if (sections[sectionId]?.order === undefined) {
      setSections(prev => ({
        ...prev,
        [sectionId]: {
          ...prev[sectionId],
          order: nextSectionOrder++,
        },
      }));
    }
  }, [sectionId, sections, setSections]);

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 2, mb: 3, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0' }}>
      <SectionLayoutSettings sectionId={sectionId} sections={sections} setSections={setSections} />
      <SectionControls sectionId={sectionId} sections={sections} setSections={setSections} />
      <SectionBackgroundSettings
        sectionId={sectionId}
        sections={sections}
        setSections={setSections}
      />
      <HeaderEditor sectionId={sectionId} headers={headers} setHeaders={setHeaders} default_profiles={default_profiles} work_item_presets={work_item_presets} sections={sections} />
      <SectionItemsList
        sectionId={sectionId}
        items={items}
        sections={sections}
        setSections={setSections}
        work_item_presets={work_item_presets}
      />
    </Paper>
  );
};

export default SectionDetailPanel;